"use client";
import { useState } from "react";
import * as S from "./styles.ts";
import { Form, H2, UniversalLink } from "@template/components";

export const ResellerForm = () => {
  const [formValue, setFormValue] = useState<Record<string, string>>({
    name: "",
    email: "",
    number: "",
    enquiry: "",
  });
  const [errors, setErrors] = useState<any>(formValue);
  const [loading, setLoading] = useState<boolean>(false);
  const [checked, setChecked] = useState<boolean>(false);
  const [successMessage, setSuccessMessage] = useState<string | null>(null);
  const handleCheckboxChange = () => {
    setChecked(!checked);
  };

  const apiUrl = "https://www.yay.com";
  const apiSuffix = "/api/enquiry";
  const apiEndpoint = `${apiUrl}${apiSuffix}`;

  const sendData = async ({
    name,
    email,
    number,
    enquiry,
  }: Record<string, string>) => {
    setLoading(true);
    try {
      const request = await fetch(apiEndpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ name, email, number, enquiry }),
      });
      setSuccessMessage("Thanks! Your enqury has been sent");
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (data: Record<string, any>) => {
    await sendData(data);
  };

  return (
    <>
      {!successMessage ? (
        <Form
          value={formValue}
          onChange={setFormValue}
          submit={{
            text: "Submit",
            onSubmit: handleSubmit,
            loading: loading,
          }}
          inputs={[
            {
              label: "Full Name",
              name: "name",
              error: errors.name,
              span: 6,
              required: true,
            },
            {
              label: "Email",
              name: "email",
              placeholder: "name@example.com",
              validation: {
                regex: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                error: "Please enter a valid email address",
              },
              error: errors.email,
              span: 6,
              required: true,
            },
            {
              label: "Phone Number",
              name: "number",
              prefix: "+44",
              placeholder: "0207 123 4567",
              error: errors.number,
              span: 12,
            },
            {
              label: "Enquiry",
              name: "enquiry",
              error: errors.enquiry,
              placeholder: "Enter a description...",
              span: 12,
              type: "textarea",
              required: true,
            },
          ]}
          checkbox={{
            name: "Privacy policy",
            label: (
              <>
                You agree to our friendly{" "}
                <UniversalLink
                  styled
                  href="/about/privacy"
                >
                  Privacy Policy
                </UniversalLink>
              </>
            ),

            checked: checked,
            onChange: handleCheckboxChange,
          }}
        />
      ) : (
        <S.SuccessMessageContainer>
          <H2>{successMessage}</H2>
        </S.SuccessMessageContainer>
      )}
    </>
  );
};
